import React from "react";
import { Typography } from "@material-ui/core";
import styles from "../styles";

function AccommodationsPageText() {
  const useStyles = styles;
  const classes = useStyles();

  return (
    <>
      <Typography
        component="p"
        className={classes.newFont}
        style={{ marginTop: "24px", marginBottom: "24px", width: "100%", textAlign: "left" }}
      >
        {`Welcome to your Accommodations Dashboard!`}
      </Typography>
      <Typography component="p" className={classes.newFont} style={{ width: "100%", textAlign: "left" }}>
        {`We designed a streamlined view of your students who have approved ADA or Title IX accommodations. Your dashboard makes reviewing and acknowledging each notification straightforward, allowing you to both stay-up-to-date and confidently support each student throughout your class.`}
      </Typography>
    </>
  );
}

export default AccommodationsPageText;
